import { useTranslation } from 'utils/i18n';

// components
import FeatureIcon from '../featureIcon';

export const FavouriteButton = ({
  favouritedState,
  type,
  handleFavouriteButtonClick,
}: {
  favouritedState?: boolean;
  type?: string;
  handleFavouriteButtonClick?: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <button
      data-testid="favouriteButton"
      className="favourite-button"
      onClick={handleFavouriteButtonClick}
    >
      {favouritedState && (
        <FeatureIcon
          type="favourite-on"
          name={`${t('favourite.remove_from_my_saved')} ${type}`}
          displaySvgIcon
        />
      )}
      {!favouritedState && (
        <FeatureIcon
          type="favourite-off"
          name={`${t('favourite.add_to_my_saved')} ${type}`}
          displaySvgIcon
        />
      )}
    </button>
  );
};

export default FavouriteButton;
